<template>
  <router-view />
</template>

<script>
export default {
  name: 'Admin.Messages'
}
</script>

<style scoped>

</style>
